<template>
  <div class="search">
    <h1 class="search__title">Witaj kierowco</h1>
    <p class="search__subtitle">Sprawdź status naprawy swojego pojazdu.</p>

    <form
      class="field"
      :class="{ 'field--error': showError }"
      @submit.prevent="submit"
    >
      <input
        ref="input"
        v-model.trim="orderNumber"
        type="text"
        class="field__input"
        placeholder="Numer rejestracyjny"
        autocomplete="off"
        autocapitalize="characters"
        spellcheck="false"
        @input="showError = false"
      />
      <button
        type="submit"
        class="field__btn"
        :disabled="loading"
        aria-label="Szukaj"
      >
        <span v-if="loading" class="spinner spinner--sm"></span>
        <svg v-else viewBox="0 0 24 24" class="icon" aria-hidden="true">
          <circle cx="11" cy="11" r="7" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </button>
    </form>
    <span v-if="showError" class="field__msg"
      >Wpisz numer rejestracyjny pojazdu.</span
    >

    <p class="search__hint">Twoje auto pod kontrolą.</p>

    <transition name="modal">
      <div v-if="notFound" class="modal" @click.self="notFound = false">
        <div class="modal__card">
          <button
            class="modal__close"
            @click="notFound = false"
            aria-label="Zamknij"
          >
            <svg viewBox="0 0 24 24" class="icon">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
          <div class="modal__icon modal__icon--warn">
            <svg viewBox="0 0 24 24" class="icon">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="13" />
              <line x1="12" y1="16.5" x2="12" y2="16.6" />
            </svg>
          </div>
          <p class="modal__msg">
            Nie znaleźliśmy pojazdu o tym numerze.<br />Sprawdź numer i spróbuj
            ponownie.
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Search",
  data() {
    return {
      orderNumber: "",
      loading: false,
      showError: false,
      notFound: false,
    };
  },
  methods: {
    ...mapActions(["setOrderDetails"]),
    submit() {
      if (!this.orderNumber) {
        this.showError = true;
        this.$refs.input.focus();
        return;
      }
      this.loading = true;
      this.setOrderDetails(this.orderNumber)
        .then((data) => {
          if (data) {
            this.$router.push({
              name: "Details",
              params: { orderNumber: data.orderNumber },
            });
          } else {
            this.notFound = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
